/* Reveal the requested topic in an unpublished help review. No data storage or network calls. */
function revealTopic() {
  let key;
  try { key = decodeURIComponent(location.hash.slice(1)); } catch { return; }
  const target = document.getElementById(key);
  if (target instanceof HTMLDetailsElement && target.hasAttribute('data-review-topic')) target.open = true;
}
revealTopic();
window.addEventListener('hashchange', revealTopic);
